/*set components*/
import Home  from './Home';
import Condominio  from './Condominio';

/*set icons*/
import Face3Icon from '@mui/icons-material/Face3';


export const routes_modules = [
  {
    name: "Condominios",
    path: "/",
    component: Home,
    menu: true,
    private: false,
    icon: <Face3Icon />,
    title: "Condominios",
    subtitle: "Desarrollos inmobiliarios"
  },
  {
    name: "Condominio",
    path: "/*",
    component: Condominio,
    menu: true,
    private: false,
    icon: <Face3Icon />,
    title: "Condominios",
    subtitle: "Desarrollos inmobiliarios"
  },
];
